<template>
  <div>
    <b-jumbotron header="" lead="Faculty Workload">
       <workload-dashboard></workload-dashboard>
    </b-jumbotron>
    <!-- <b-jumbotron header="" lead="Community Partnerships and Awards">
      <widget heading="Expertise and Tags" icon="file-invoice-dollar">
        <tags :tags="tags" :can-edit="isOwner" :app="appName" :object="objectName" :object-id="user.userId" @success="loadTags()"/>
      </widget>
      <widget heading="Translational Teams" icon="users">
        <translational-teams :items="translationalTeams"></translational-teams>
      </widget>
      <widget heading="Sponsored Awards" icon="file-invoice-dollar">
        <awards :awards="awards"></awards>
      </widget> 
      <widget heading="Other Projects" icon="pencil-alt">
        <projects :items="projects"></projects>
      </widget> 
      <widget heading="Proposals" icon="file-invoice-dollar">
        <proposals :proposals="proposals"></proposals>
      </widget> 
      <widget heading="Research Collaborators" icon="users"> 
        <collaborators :collaborators="collaborators"></collaborators>
      </widget>
      <widget heading="Community Partnerships" icon="hands-helping">
        <community-partners :items="communityPartners"></community-partners>
      </widget>     
    </b-jumbotron>
     -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import authApi from "../api/auth";
import employeeApi from "../api/employees";
import tagsApi from "../api/objectTags";
import workloadDashboard from "../views/workloads/workload-dashboard";
// import awards from "../components/experts/awards";
// import proposals from "../components/experts/proposals";
// import projects from "../components/experts/projects";
// import collaborators from "../components/experts/research-collaborators";
// import communityPartners from "../components/experts/community-partners";
// import translationalTeams from "../components/experts/translationalTeams";
import Tags from "../components/tags";
import roleChecks from "../misc/role-checks";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  mixins: [roleChecks],
  data() {
    return {
      // awards: [],
      // projects: [],
      // proposals: [],
      // collaborators: [],
      // communityPartners: [],
      // expertise: [],
      tags: [],
      // translationalTeams: [],
      appName: process.env.VUE_APP_NAME,
      objectName: "Employees"
    };
  },

  components: {
    "workload-dashboard": workloadDashboard,
    // awards: awards,
    // collaborators: collaborators,
    // "community-partners": communityPartners,
    // translationalTeams,
    Tags
    // projects,
    // proposals
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isOwner: function() {
      if (this.isExpertsAdmin) {
        return true;
      }
      return false;
    }
  },

  methods: {
    loadTags() {
      var that = this;
      tagsApi
        .getObjectTags(this.appName, this.objectName, this.user.userId)
        .then(response => {
          that.tags = response.data;
        });
    }
  },

  created() {
    var that = this;

    // impersonate or stop impersonation
    var routeName = this.$route.name;
    if (routeName === "impersonation") {
      var asuriteId = this.$route.params.asuriteId;
      authApi
        .impersonate(asuriteId)
        .then(function() {
          that.$router.push({ path: "/" });
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (routeName === "stopimpersonation") {
      authApi
        .stopImpersonation()
        .then(function() {
          that.$router.push({ path: "/" });
        })
        .catch(function(error) {
          console.log(error);
        });
    }

    // employeeApi
    //   .getAwards(this.user.userId)
    //   .then(function(response) {
    //     that.awards = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getProjects(this.user.userId)
    //   .then(function(response) {
    //     that.projects = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getProposals(this.user.userId)
    //   .then(function(response) {
    //     that.proposals = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getCommunityPartners(this.user.userId)
    //   .then(function(response) {
    //     that.communityPartners = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getCollaborators(this.user.userId)
    //   .then(function(response) {
    //     that.collaborators = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getExpertise(this.user.userId)
    //   .then(function(response) {
    //     that.expertise = response.data;
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });

    // employeeApi
    //   .getTranslationalTeams(this.user.userId)
    //   .then(response => {
    //     this.translationalTeams = response.data;
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });

    this.loadTags();
  }
};
</script>

<style scoped>
.badge-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.badge-primary:hover {
  background-color: #a02048;
}
</style>
